import { Tooltip, Typography } from "antd";
import { ReactElement, ReactNode } from "react";
import styled from "styled-components";

export interface SettingPanelCollapsedProps {
  title: string;
  icon: ReactNode;
  value: string | number;
}

export default function SettingPanelCollapsed({ title, icon, value }: SettingPanelCollapsedProps): ReactElement {
  return (
    <Box>
      <Tooltip title={title} placement="right">
        <IconBox aria-hidden>{icon}</IconBox>
      </Tooltip>
      <Value aria-label={title}>{value}</Value>
    </Box>
  );
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconBox = styled.div`
  font-size: 1.25em;
  color: ${p => p.theme.colorTextSecondary};
`;

const Value = styled(Typography.Text)`
  font-size: ${p => p.theme.fontSizeSM}px;
  user-select: none;
`;
